import React, { useEffect, useState, Suspense } from 'react';
import Tilt from 'react-parallax-tilt';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import daftarWarga from '../../assets/images/fitur/Daftar Warga.png';
import daftarPenduduk from '../../assets/images/fitur/Data Penduduk.png';
import daftarPetugas from '../../assets/images/fitur/data_petugas.png';
import pengajuanSurat from '../../assets/images/fitur/pengajuan_surat.png';
import jenisAset from '../../assets/images/fitur/Daftar Jenis Aset.png';
import distribusiBantuan from '../../assets/images/fitur/Daftar Jenis Bantuan.png';
import webProfile from '../../assets/images/fitur/web_desa.png';
import mobileApps from '../../assets/images/fitur/mobile_apps.png';
import mesinAnjungan from '../../assets/images/fitur/mesin_anjungan.png';

import AOS from 'aos';
import 'aos/dist/aos.css';

const Fitur = (props) => {
  // Importing Section
  const Navbar = React.lazy(() => import('../../component/Navbar/NavBar'));
  const Footer = React.lazy(() => import('../../component/Footer/Footer'));
  const ScrollToTop = React.lazy(() => import('../../component/ScrollToTop'));

  const [navItems, setNavItems] = useState([
    { id: 1, idnm: '/', navheading: 'Beranda', active: false, box: false },
    {
      id: 2,
      idnm: 'fitur',
      navheading: 'Fitur',
      active: true,
      box: false,
    },
    {
      id: 4,
      idnm: 'kontak',
      navheading: 'Kontak',
      active: false,
      box: false,
    },
    {
      id: 6,
      idnm: 'register',
      navheading: 'Register',
      active: false,
      box: true,
    },
  ]);

  const [pos, setPos] = useState(document.documentElement.scrollTop);
  const [imglight, setImglight] = useState(false);
  const [navClass, setNavClass] = useState('');

  const scrollNavigation = () => {
    var scrollup = document.documentElement.scrollTop;
    if (scrollup > pos) {
      setNavClass('nav-sticky');
      setImglight(false);
    }
  };

  const daftarFitur = (props.payload?.fiturs && props.payload.fiturs.length > 0)
    ? props.payload.fiturs
    : [];

  //set preloader div
  const PreLoader = () => {
    return (
      <div id='preloader'>
        <div id='status'>
          <div className='spinner'>
            <div className='bounce1'></div>
            <div className='bounce2'></div>
            <div className='bounce3'></div>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    window.addEventListener('scroll', scrollNavigation, true);
    // Refresh AOS animations after component mounts (handles late data fetch renders)
    setTimeout(() => {
      AOS.refresh();
    }, 100);
  }, []);

  return (
    <React.Fragment>
      <Suspense fallback={PreLoader()}>
        {/* Importing Navbar */}
        <Navbar navItems={navItems} navClass={navClass} imglight={imglight} />

        <>
          <section className="fitur-hero">
            <div className="blob-1"></div>
            <div className="blob-2"></div>
            <Container>
              <h1 className="hero-title" data-aos="zoom-in-up" data-aos-duration="1000">
                Jelajahi Fitur <span>Unggulan</span> Kami
              </h1>
              <p className="hero-subtitle" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
                Temukan berbagai layanan dan inovasi terbaik yang kami sediakan untuk memudahkan pengelolaan serta meningkatkan potensi desa Anda.
              </p>
            </Container>
          </section>

          <section className="fitur-overlap-section">
            <Container>
              {daftarFitur.map((data, i) => {
                const isEven = i % 2 === 0;
                return (
                  <div 
                    className={`fitur-row ${isEven ? 'row-even' : 'row-odd'}`} 
                    key={i}
                  >
                    <div 
                      className="fitur-image-wrapper" 
                      data-aos={isEven ? "flip-left" : "flip-right"}
                      data-aos-duration="1200"
                    >
                      <img src={data.icon} alt={data.title} />
                    </div>
                    
                    <Tilt
                      className="fitur-text-card"
                      tiltMaxAngleX={8}
                      tiltMaxAngleY={8}
                      perspective={1000}
                      transitionSpeed={1000}
                      scale={1.02}
                      gyroscope={true}
                      data-aos="zoom-in-up"
                      data-aos-duration="1200"
                      data-aos-delay="300"
                    >
                      <h2>{data.title}</h2>
                      <div className="fitur-subtitle">{data.subtitle}</div>
                      <p 
                        className="fitur-desc"
                        data-aos={isEven ? "slide-subtle-left" : "slide-subtle-right"}
                        data-aos-duration="1000"
                        data-aos-delay="400"
                      >
                        {data.description}
                      </p>
                    </Tilt>
                  </div>
                );
              })}
            </Container>
          </section>
        </>
        <Footer />
        <ScrollToTop />
      </Suspense>
    </React.Fragment>
  );
};

const mapStateToProps = ({ mergeCms }) => ({
  payload: mergeCms.payload,
});

export default connect(mapStateToProps)(Fitur);
